import { connect } from 'react-redux';
import { assign } from 'lodash-es';
import compose from 'recompose/compose';
import { downloadAssets } from '../../../actionCreators/downloadAssets';
import ScreenAssets from '../../../components/handoff/sidebar/ScreenAssets';
import { getCurrentScreen } from '../../../selectors/screen';
import { getElements } from '../../../selectors/handoff';
import { isDownloading, hasDownloaded, } from '../../../selectors/downloadAssets';
import { hasAssets } from '../../../utils/handoff/element';
import onlyIf from '../../../hocs/onlyIf';
import { SUCCESS } from '../../../constants/requestStatus';
function mapStateToProps(state) {
    var currentScreen = getCurrentScreen(state);
    var elements = getElements(state).filter(hasAssets);
    return {
        screenID: currentScreen.id,
        sourcePlatform: currentScreen.sourcePlatform,
        elements: elements,
        areDownloading: isDownloading(state, { screenID: currentScreen.id }),
        hasDownloaded: hasDownloaded(state, { screenID: currentScreen.id }),
        requestStatus: state.handoff.requestStatus,
    };
}
function mergeProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    var newProps = {
        download: function () {
            dispatch(downloadAssets({ screenID: stateProps.screenID }));
        },
    };
    return assign({}, ownProps, stateProps, newProps);
}
export default compose(connect(mapStateToProps, null, mergeProps), onlyIf(function (props) { return props.requestStatus === SUCCESS; }))(ScreenAssets);
